const SUPPORTED_LANGUAGES = ['fr', 'de'];
const DEFAULT_LANGUAGE = 'fr';
const LEGACY_LANGUAGE_KEY = 'selected_target_lang';
const LANGUAGE_KEY = 'preferred_target_lang';

const getLocalStorage = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.localStorage;
  } catch (_) {
    return null;
  }
};

const normalizeLanguage = (lang) =>
  lang && SUPPORTED_LANGUAGES.includes(lang.toLowerCase()) ? lang.toLowerCase() : null;

const readLanguagePreference = () => {
  const storage = getLocalStorage();
  if (!storage) {
    return null;
  }

  const currentValue = normalizeLanguage(storage.getItem(LANGUAGE_KEY));
  if (currentValue) {
    return currentValue;
  }

  const legacyValue = normalizeLanguage(storage.getItem(LEGACY_LANGUAGE_KEY));
  if (legacyValue) {
    storage.setItem(LANGUAGE_KEY, legacyValue);
    return legacyValue;
  }

  return null;
};

const writeLanguagePreference = (value) => {
  const storage = getLocalStorage();
  if (!storage) {
    return;
  }
  const normalized = normalizeLanguage(value);
  if (normalized) {
    storage.setItem(LANGUAGE_KEY, normalized);
  } else {
    storage.removeItem(LANGUAGE_KEY);
  }
};

export {
  SUPPORTED_LANGUAGES,
  DEFAULT_LANGUAGE,
  LANGUAGE_KEY,
  LEGACY_LANGUAGE_KEY,
  normalizeLanguage,
  readLanguagePreference,
  writeLanguagePreference,
};
